module.exports = __webpack_public_path__ + "img/blue_108.2a195eea.png";